import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {WebLink} from "..";
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "WebLink"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "<WebLink>"
      }), " is a link to an website, displayed as rich media (title, description, and opengraph image)."]
    }), "\n", _jsx(_components.h2, {
      children: "Examples"
    }), "\n", _jsx(WebLink, {
      url: "https://twitter.com",
      style: {
        marginBottom: 16
      }
    }), "\n", _jsx(WebLink, {
      url: "https://figma.com",
      style: {
        marginBottom: 16
      }
    }), "\n", _jsx(WebLink, {
      url: "https://www.framer.com/motion/",
      style: {
        marginBottom: 16
      }
    }), "\n", _jsx(WebLink, {
      url: "https://formatjs.io",
      style: {
        marginBottom: 16
      }
    }), "\n", _jsx(WebLink, {
      url: "https://www.typescriptlang.org",
      style: {
        marginBottom: 16
      }
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
